// extracted by css-extract-rspack-plugin
export default {"cls1":"LettersModal-cls1_bp4","cls2":"LettersModal-cls2_IRM LettersModal-cls1_bp4"};